import { createContext } from 'react';
const actionNotProvided = () => {
    console.warn('Action not provided to context');
};
const defaultContext = {
    onColumnsChange: actionNotProvided,
    afterSubmit: actionNotProvided,
    columns: [],
    columnsState: [],
    deficiencyStatusesForSelect: [],
    resolutionStatusesForSelect: [],
    screen: null,
    screenId: null
};
const ColumnMenuContext = createContext(defaultContext);
export default ColumnMenuContext;
